import { fetchProjects as napiFetchProject } from 'src/services/napi/projects/fetchProjects';
import { getProjectProvidersAction } from './ProviderActions';
import { createProject, updateProject, deleteProject } from '../services/napi';
import {
  PROJECT_FETCH_SUCCESS,
  PROJECT_FETCH_FAIL,
  SET_CURRENT_PROJECT,
  PROJECT_CREATE_SUCCESS,
  PROJECT_DELETE_SUCCESS,
  PROJECT_UPDATE_SUCCESS
} from '../constant/actionType';
import { divideQueryParams } from '../util/queryParams';

const store = window.localStorage;

function fetchProjectFail() {
  return {
    error: 'PROJECT_FETCH_FAIL',
    type: PROJECT_FETCH_FAIL
  };
}

function createProjectSuccess(data) {
  return { data, type: PROJECT_CREATE_SUCCESS };
}

function updateProjectSuccess(data) {
  return { data, type: PROJECT_UPDATE_SUCCESS };
}

export function setCurrentProject(data) {
  return async (dispatch) => {
    store.setItem('currentProject', JSON.stringify(data));
    dispatch({ data, type: SET_CURRENT_PROJECT });

    dispatch(getProjectProvidersAction());
  };
}

function getCurrentProject(projects) {
  const queryParameter = window.location.search;
  const paramsObj = divideQueryParams(queryParameter);
  const idFromUrl = paramsObj.get('id');
  const dataFromLocalStorage = JSON.parse(store.getItem('currentProject'));

  if (idFromUrl && idFromUrl !== dataFromLocalStorage?._id) {
    const project = projects.filter((project) => project._id === idFromUrl);
    const currentProject = project[0] || null;
    store.setItem('currentProject', JSON.stringify(currentProject));
    return currentProject;
  }
  if (projects.length === 1) {
    const project = projects[0];
    if (project?._id !== dataFromLocalStorage?._id) {
      store.setItem('currentProject', JSON.stringify(project));
    }
    return project;
  }

  return dataFromLocalStorage;
}

export function fetchProjects(onSuccess) {
  return async (dispatch) => {
    try {
      const response = await napiFetchProject();
      const projects = response?.projects;
      const currentProject = getCurrentProject(projects);

      dispatch({ data: response, type: PROJECT_FETCH_SUCCESS });

      if (currentProject) {
        dispatch({
          data: currentProject,
          type: SET_CURRENT_PROJECT
        });
        dispatch(getProjectProvidersAction());
      } else {
        dispatch({
          data: null,
          type: SET_CURRENT_PROJECT
        });
      }

      onSuccess();
    } catch (error) {
      dispatch(fetchProjectFail());
    }
  };
}

export function setCurrentProjectByName(name) {
  return async (dispatch, getState) => {
    const projects = await getState().project.projects;
    let project = '';

    for (let i = 0; i < projects.length; i++) {
      if (projects[i].name === name) {
        project = projects[i];
        break;
      }
    }

    dispatch(setCurrentProject(project));
  };
}

export function createProjectAction(name, tags, onCreateSuccess) {
  return async (dispatch) => {
    try {
      const response = await createProject({ name, tags });

      dispatch(createProjectSuccess(response.data));
      onCreateSuccess();
    } catch (error) {
      console.error(`FAILED TO CREATE PROJECT: ${error}`);
    }
  };
}

export function deleteProjectAction(projectId) {
  return async (dispatch) => {
    try {
      await deleteProject(projectId);
      dispatch({ data: projectId, type: PROJECT_DELETE_SUCCESS });
    } catch (error) {
      console.error(`FAILED TO DELETE PROJECT: ${error}`);
    }
  };
}

export function updateProjectLanguageAction(project, languages) {
  return async (dispatch) => {
    try {
      project.languages = languages;
      dispatch(updateProjectSuccess(project));
    } catch (error) {
      console.error(error);
    }
  };
}

export function updateProjectAction(project) {
  return async (dispatch, getState) => {
    try {
      const { _id: projectId } = getState().project.currentProject;
      const response = await updateProject(projectId, project);
      dispatch(updateProjectSuccess(response.data));
    } catch (error) {
      console.error(`FAILED TO UPDATE PROJECT: ${error}`);
    }
  };
}
